import { Pipe, PipeTransform } from '@angular/core';
import { FileDto } from 'src/app/models/FileDto';
import { User } from 'src/app/models/User';

@Pipe({
  name: 'createdByFilter',
  standalone: true
})
export class CreatedByFilterPipe implements PipeTransform {
  /**
   * Filters an array of files based on the creator's name.
   * Only files created by the specified user are included.
   *
   * @param {FileDto[]} files - The array of files to filter.
   * @param {User} createdBy - The user whose name is used to filter the files.
   * @returns {FileDto[]} - The filtered array of files.
   */
  transform(files: FileDto[], createdBy: User): FileDto[] {
    // Check if files or createdBy are not provided
    if (!files || !createdBy) {
      return files;
    }

    // Filter the files array to include only files created by the specified user
    return files.filter((file) => {
      // Construct the full name of the file creator and convert it to lowercase
      const fullName =
        `${file.createdBy?.firstname} ${file.createdBy?.lastname}`.toLowerCase();

      // Check if both firstname and lastname are provided in createdBy
      if (createdBy.firstname && createdBy.lastname) {
        return (
          fullName.includes(createdBy.firstname.toLowerCase()) ||
          fullName.includes(createdBy.lastname.toLowerCase())
        );
      }

      // Check if only firstname is provided in createdBy
      if (createdBy.firstname && !createdBy.lastname) {
        return fullName.includes(createdBy.firstname.toLowerCase());
      }

      // Check if only lastname is provided in createdBy
      if (!createdBy.firstname && createdBy.lastname) {
        return fullName.includes(createdBy.lastname.toLowerCase());
      }

      // Return false if neither firstname nor lastname is provided in createdBy
      return false;
    });
  }
}
